'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _tooltip = require('./tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withTooltip(Component) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var WithTooltip = function (_React$Component) {
    _inherits(WithTooltip, _React$Component);

    function WithTooltip(props) {
      _classCallCheck(this, WithTooltip);

      var _this = _possibleConstructorReturn(this, (WithTooltip.__proto__ || Object.getPrototypeOf(WithTooltip)).call(this, props));

      _this.state = {
        target: null,
        isTooltipVisible: false
      };
      return _this;
    }

    _createClass(WithTooltip, [{
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            _props$tooltip = _props.tooltip,
            tooltip = _props$tooltip === undefined ? defaults.tooltip : _props$tooltip,
            tooltipSize = _props.tooltipSize,
            props = _objectWithoutProperties(_props, ['tooltip', 'tooltipSize']);

        var _state = this.state,
            target = _state.target,
            isTooltipVisible = _state.isTooltipVisible;


        return _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(Component, _extends({}, props, {
            onMouseEnter: function onMouseEnter(event) {
              _this2.setState({
                isTooltipVisible: true,
                target: event.currentTarget.nodeName === 'svg' ? event.currentTarget.parentElement : event.currentTarget
              });
            },
            onMouseLeave: function onMouseLeave() {
              return _this2.setState({ isTooltipVisible: false });
            }
          })),
          isTooltipVisible && tooltip && _react2.default.createElement(
            _tooltip2.default,
            { target: target, tooltipSize: tooltipSize },
            tooltip
          )
        );
      }
    }]);

    return WithTooltip;
  }(_react2.default.Component);

  WithTooltip.propTypes = _extends(Component.propTypes || {}, {
    className: _propTypes2.default.string,
    tooltipSize: _propTypes2.default.oneOf(['small', 'medium', 'large'])
  });

  return WithTooltip;
}

exports.default = withTooltip;